export default __webpack_public_path__ + "static/media/743.617ee6db.png";